/* eslint-disable no-param-reassign */
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import decorateStoreWithSagas from './sagas/decorateStore';
import defaultState from './state';
import trackingMiddleware from './tracking';
import localforageMiddleware from './middlewares/localforage';
import errorLogMiddleware from './middlewares/errorLog';
import cookiesMiddleware from './middlewares/cookies';
import rootReducer from './rootReducer';
import config from '../parameters/client/config';

export default initialState => {
  const sagaMiddleware = createSagaMiddleware();

  const state = initialState == null ? defaultState : initialState;

  const middlewares = [
    sagaMiddleware,
    trackingMiddleware,
    localforageMiddleware,
    errorLogMiddleware,
    cookiesMiddleware,
  ];
  const enhancers = [applyMiddleware(...middlewares)];

  /* eslint-disable no-underscore-dangle */
  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers =
    config.enableReduxTools &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  /* eslint-enable no-underscore-dangle */

  const store = createStore(rootReducer, state, composeEnhancers(...enhancers));

  decorateStoreWithSagas(store, sagaMiddleware);

  // Start listening sagas for the first time
  store.runSaga();

  return store;
};



// WEBPACK FOOTER //
// ./app/store.js